import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SearchIcon from "@mui/icons-material/Search";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import {
  IconButton,
  Typography
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, GridColDef, GridRowId } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import { usePersistentState, markNavigationPreserve, consumeNavigationPreserve, clearNamespace } from "../../hooks/persistence";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {
  useHistory,
  useLocation,
  useParams
} from "react-router-dom";
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import TrashIcon from "../../assets/images/icons/Trash.svg";
import Constant from "../../Constant";
import { CommonService } from "../../Service/CommonService";
import { OrderApiService } from "../../Service/OrderApiService";
import Spinner from "../Common/Spinner";
import StatusDropdown from "../Common/StatusDropdown";
import "../Dynamic/UserList.scss";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import Select from "react-select";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import DataGridLoader from "../Common/DataGridLoader";

const ActiveOrder = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [tableData, setTableData] = useState<any[]>([]);
  const [reviewOrderCount, setReviewOrderCount] = useState(0);
  let accepted: any[] = [];
  const disableAction = useRef(false);
  const [isNeedReviewClicked, setNeedReviewClicked] = useState(false);
  const selectedRows = useRef(accepted);
  const rejectionNote = useRef("");
  const trackNumber = useRef("");
  const ownershipTransferDate = useRef("");
  const [ttbFile, setTTBFile] = useState<File[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams<{ id: string }>();
  const params = id === undefined ? CommonService.getCompanyId() : id;
  /* interface StatusDetails {
     id: string;
     status: string;
   }*/
  const statusDetailsRef = useRef({
    id: "",
    status: "",
    rejectionNote: "",
    trackNumber: "",
    ownershipTransferDate: "",
    quantity: 0,
    assignedTo: ""
  });
  const [trackNumberValue, setTrackNumber] = useState<string>("");
  const [ownershipTransferDateValue, setOwnershipTransferDate] = useState<string>("");
  const [selectedWarehouseUser, setSelectedWarehouseUser] = useState<string>("");
  const [isApproved, setIsApproved] = useState(false); 
  const [isBeforeCancel, setIsBeforeCancel] = useState(false);
  const [isAfterCancel, setIsAfterCancel] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [rejectionNoteValue, setNote] = useState<string>("");
  const [error, setError] = useState<string>("");
  let dashboardPrefrence = "";
  const [totalCount, setTotalCount] = useState(0);
  const [isInWarehouse, setIsInWarehouse] = useState(false);
  const [warehouseUserList, setWarehouseUserList] = useState([]);  
  const handleClose = () => {
    setShow(false);
    setNote("");
    setTrackNumber("");
    setOwnershipTransferDate("");
    setSelectedWarehouseUser("");
    setError("");
  };
  const toTitleCase = (str: string) => {
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };
  const controllerRef = useRef<AbortController | null>(null);

  const initialFilter = {
    requestNumber: null,
    requestedOn: null,
    modifiedOn: null,
    ownerRequestedOn: null,
    ownerModifiedOn: null,
    totalInventories: null,
    quantity: null,
    finalAmount: null,
    companyName: null,
    firstName: null,
    status: null,
  };

  const _filterInitRef = useRef(false);
  if (!_filterInitRef.current) {
    _filterInitRef.current = true;
    if (!consumeNavigationPreserve("active-order")) {
      clearNamespace("active-order");
    }
  }

  const [search, setSearch] = usePersistentState<string>("active-order", "search", "");
  const [page, setPage] = usePersistentState<number>("active-order", "page", 0);
  const [pageSize, setPageSize] = usePersistentState<number>("active-order", "pageSize", 50);
  const [sortField, setSortField] = usePersistentState<string>("active-order", "sortField", "CreatedModifiedDate");
  const [sortDirection, setSortDirection] = usePersistentState<string>("active-order", "sortDirection", "asc");
  const [filter, setFilter] = usePersistentState<any>("active-order", "filter", initialFilter);

  const buttonRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const statusOptions = [
    { value: "PENDING_REVIEW", label: "Pending Review" },
    { value: "UNDER_REVIEW", label: "Under Review" },
    { value: "ACCEPTED", label: "Accepted" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "CONTRACT_SENT", label: "Contract Sent"},
    { value: "CONTRACT_EXECUTED", label: "Contract Executed"},
    { value: "PAYMENT_RECEIVED", label: "Payment Received" },
    { value: "INVOICE_SENT", label: "Invoice Sent" },
    { value: "OWNERSHIP_TRANSFERRED", label: "Ownership Transferred"},
    { value: "IN_TRANSIT", label: "In Transit"},
    { value: "REJECTED", label: "Rejected" },
    { value: "CANCELLED", label: "Cancelled" },
    { value: "CLOSED", label: "Closed" },
  ];

  useEffect(() => {
    
    const handleClickOutside = (event: MouseEvent) => {
      if (
          divRef.current &&
          !divRef.current.contains(event.target as Node) &&
          buttonRef.current &&
            !buttonRef.current.contains(event.target as Node)
          ) {
            setShowDropdown(false);  
          }
        }; 
          
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);  
        };
        
  }, [showDropdown]); // Only run when dropdown is toggled

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  }

  const handleStatusChange = async (newStatus: string, oldStatus: string, rowId: string, quantity: number) => {
    console.log(newStatus);

    const orderStatus = newStatus?.replace(/ /g, "_");

    //create the object to send
    const sd = {
      id: rowId,
      companyId: CommonService.getCompanyId(),
      status: orderStatus.toUpperCase(),
      trackNumber: "",
      rejectionNote: "",
      ownershipTransferDate: "",
      quantity: quantity,
      assignedTo: selectedWarehouseUser
    };

    statusDetailsRef.current = sd;

    if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED) {
      setIsApproved(false);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED || statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT) {
      setIsApproved(true);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE) {
      setIsInWarehouse(true);
      let response = await OrderApiService.fetchAllWarehouseUser();
      setWarehouseUserList(response.data);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.CANCELLED) {
      if(["PENDING_REVIEW", "UNDER_REVIEW"].includes(oldStatus)){
        setIsBeforeCancel(true);
        setIsAfterCancel(false);
      }else if(["ACCEPTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED"].includes(oldStatus)){
        setIsAfterCancel(true);
        setIsBeforeCancel(false);
      }
      handleShow();
    } else if (["UNDER_REVIEW", "ACCEPTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "CLOSED"].includes(statusDetailsRef.current.status)) {
      setIsApproved(false);
      setIsAfterCancel(false);
      setIsBeforeCancel(false);
      setIsInWarehouse(false);
      handleShow();
    } else {
      changeOrderStatus();
    }
  };

  const changeOrderStatus = async () => {

    if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED && rejectionNoteValue.trim().length == 0) {
      setError("Please enter rejection note");
      return;
    }

    if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED && rejectionNoteValue.trim().length > 500) {
      setError("Rejection note can not be more than 500 characters");
      return;
    }

    if (statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED) {
      if(ownershipTransferDateValue.trim().length === 0){
        setError("Please enter date of transfer");
        return;
      }

      const transferDate = new Date(ownershipTransferDateValue);
      const today = new Date(CommonService.getTodayInTimeZone());
      today.setHours(0, 0, 0, 0);
      transferDate.setHours(0, 0, 0, 0);

      if (transferDate < today) {
        setError("Ownership transfer date cannot be in the past.");
        return;
      }
    }

    if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT && trackNumberValue.trim().length === 0) {
      setError("Please enter track number");
      return;
    }

    if(statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE && selectedWarehouseUser == "") {
      setError("Please Select Warehouse");
      return;
    } 

    setIsLoading(true);

    try {
      if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED ||
        statusDetailsRef.current.status === Constant.OrderStatus.CANCELLED
      ) {
        statusDetailsRef.current.rejectionNote = rejectionNote.current;
      } else if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT) {
        statusDetailsRef.current.trackNumber = trackNumber.current;
      } else if (statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED) {
        statusDetailsRef.current.ownershipTransferDate = ownershipTransferDate.current;
      } else if (statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE) {
        statusDetailsRef.current.assignedTo = selectedWarehouseUser;
      }

      await OrderApiService.changeOrderStatus(statusDetailsRef.current);
      setIsLoading(false);
      // Reload updated order requests
      reloadOrderRequest();
      if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT
        && (files.length > 0)) {
          uploadOrderRequestDocs();
      }
      handleClose();
      CommonService.Toast.fire({
        title: "Order status updated successfully",
        icon: "success",
      });
    } catch (error) {

      const errorMessage = error?.response?.data?.errorMessage ?? "";

      if (errorMessage.includes("Not enough barrels available for reservation for Order Items")) {
        CommonService.Toast.fire({
          title: "Out of Stock, please change quantity",
          icon: "error",
        });
      }

      if (errorMessage.includes("Please select the required quantity")) {
        CommonService.Toast.fire({
          title: "Please select the barrels to match the quantity",
          icon: "error",
        });
      }
    } finally {
      handleClose();
      setIsLoading(false);
    }
  };

  const fetchPendingOrdersCount = async () => {
    try {
      const response = await OrderApiService.getPendingOrdersCount();
      setReviewOrderCount(response.data);
    } catch (error) {
      console.log("error occurred while api calling");
    }
  };

  

  const fetchAllAcceptedOrders = async (
    page: number,
    pageSize: number,
    filter: any,
    sortField: any, 
    sortDirection: any
  ) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true); // Set the loading flag to true before the API call
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;

      // First fetch the count of pending orders
      //await fetchPendingOrdersCount();

      const response = await OrderApiService.getOrders(
        page,
        pageSize,
        false,
        false,
        null,
        filter,
        sortField, 
        sortDirection,
        signal
      );
      setTableData(response.data.content);
      setTotalCount(response.data.totalElements);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Set the loading flag to false after the API call completes
    }
  };

  //get all the pending orders
  const showPendingOrders = async (
    page: number,
    pageSize: number,
    tempFilter,
    sortField: any,
    sortDirection: any,
  ) => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (!isNeedReviewClicked) {
      try {
        setNeedReviewClicked(true);
        setIsLoading(true);
        setTableData([]);
        // Cancel the previous request if any
        if (controllerRef.current) {
          controllerRef.current.abort();
        }

        // Store the current controller to cancel the request if needed
        controllerRef.current = controller;

        const response = await OrderApiService.getOrders(
          page,
          pageSize,
          true,
          false,
          null,
          tempFilter,
          sortField,
          sortDirection,
          signal
        );
        setTableData(response.data.content);
        setTotalCount(response.data.totalElements);
      } catch (error) {
        console.log("error is occurred");
      } finally {
        setIsLoading(false); // Set the loading flag to false after the API call completes
      }
    } else {
      //update the status
      setNeedReviewClicked(false);
      fetchAllAcceptedOrders(page, pageSize, tempFilter, sortField, sortDirection);
    }
  };

  const justShowPendingOrders = async (
    page: number,
    pageSize: number,
    filter: any,
    sortField: any, 
    sortDirection: any
  ) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true);
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;

      const response = await OrderApiService.getOrders(
        page,
        pageSize,
        true,
        false,
        null,
        filter,
        sortField,
        sortDirection,
        signal
      );
      setTableData(response.data.content);
      setTotalCount(response.data.totalElements);
    } catch (error) {
      console.log("error is occurred");
    } finally {
      setIsLoading(false); // Set the loading flag to false after the API call completes
    }
  };

  const history = useHistory();

  const handleVisibilityClick = (event: any, params: any) => {
    // Logic to handle the click event for Visibility button
    event.stopPropagation(); // Prevent event from bubbling up to the row
    const linkPrefix = CommonService.getRole() === "SUPER_ADMIN" ? "/master" : "/user";
    markNavigationPreserve("active-order");
    history.push(`${linkPrefix}/order-detail/${params.row.id}`, { fromInternal: true });
  };

  const isUserRole = CommonService.getRole() === "ADMIN";

  //add tooltip
  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  //formate the status
  function formatStatus(status: string): string {
    const formattedStatus = status
      .split(/[_\\]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return formattedStatus;
  }

  const clicked = (event: any) => {
    if (CommonService.getRole() === "ADMIN") {
      event.preventDefault();
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if ( statusDetailsRef.current.status === Constant.OrderStatus.REJECTED ||
      statusDetailsRef.current.status === Constant.OrderStatus.CANCELLED
    ) {
      setNote(event.target.value);
      setError("");
      rejectionNote.current = event.target.value;
    } else if ( statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT ) {
      setTrackNumber(event.target.value);
      setError("");
      trackNumber.current = event.target.value;
    } else if ( statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED ){
      setOwnershipTransferDate(event.target.value);
      setError("");
      ownershipTransferDate.current = event.target.value;
    }
  };

  const handleWarehouseUserChange = (selectedOption) => {
    setSelectedWarehouseUser(selectedOption ? selectedOption.value : '');
    setError("");
  };

  const dateInputRef = useRef(null);

  const handleDateClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current?.showPicker(); // This will trigger the date picker to open
    }
  };
  const fetchUserRole = () => {
    //  if (CommonService.getRole() == 'SUPER_ADMIN')
    fetchAllAcceptedOrders(page, pageSize, filter, sortField, sortDirection);
    // else if (CommonService.getRole() == 'USER')
    //   showPendingOrders();
  };

  const handleRowClick = (params) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    markNavigationPreserve("active-order");
    history.push(`${linkPrefix}/order-detail/${params.row.id}`, { fromInternal: true });
  };

  const handleBack = () => {
    if (currentPath.startsWith("/master/active-order")) {
      history.push(`/master/service-requests-and-queue`);
    } else if (currentPath.startsWith("/master/my-warehouse/active-order/"))
      history.push(`/master/my-warehouse/service-requests/` + id);

    // history.goBack();
  };

  const openOrderRequests = async (
    page: number,
    pageSize: number,
    filter: any,
    sortField: any, 
    sortDirection: any
  ) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true);
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;

      if (currentPath.startsWith("/user/view-as-buyer/active-order"))
        dashboardPrefrence = Constant.Profile.BUYER;
      else if (currentPath.startsWith("/user/view-as-owner/active-order"))
        dashboardPrefrence = Constant.Profile.OWNER;
      else dashboardPrefrence = CommonService.getDashboardPrefrence();

      const response: any =
        await OrderApiService.getCompanyWiseOrderRequestsPagination(
          params,
          false,
          dashboardPrefrence,
          page,
          pageSize,
          filter,
          sortField, sortDirection,
          signal
        ); // Applies the status filter only if isFetchOpenRequests is true;
      setTableData(Object.values(response.data.content)); // Convert object to array
      setTotalCount(response.data.totalElements);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Set the loading flag to false after the API call completes
    }
  };

  const handleFilterChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    field: keyof any
  ) => {
    const value = event.target.value;

    // Prepare a temporary filter object with the updated field value
    const tempFilter = {
      ...filter, // Spread existing filter state
      [field]: field === "status" && value === "" ? null : value, // Update field only if the condition is met
    };

    // Update the filter state
    setFilter(tempFilter);

    if (currentPath === "/master/active-order") {
      if (isNeedReviewClicked)
        justShowPendingOrders(page, pageSize, tempFilter, sortField, sortDirection);
      else fetchAllAcceptedOrders(page, pageSize, tempFilter, sortField, sortDirection);
    } else openOrderRequests(page, pageSize, tempFilter, sortField, sortDirection);
  };


  const handleStatusFilterChange = (event: any, value: string, status: string | null) => {
    const isChecked = event.target.checked;
  
    // Convert the status string to an array
    const statusArray = status ? status.split(",") : [];
  
    // Update the status list based on checkbox state
    const updatedStatusArray = isChecked
      ? [...statusArray, value] // Add status if checked
      : statusArray.filter((s) => s !== value); // Remove status if unchecked
  
    // Convert array back to a comma-separated string
    const updatedStatus = updatedStatusArray?.length > 0 ? updatedStatusArray.join(",") : null;
  
    // Update the filter state with the modified status string
    setFilter({ ...filter, status: updatedStatus });


    if (currentPath === "/master/active-order") {
      if (isNeedReviewClicked)
        justShowPendingOrders(page, pageSize, {
          ...filter,
          status: updatedStatus,
        }, sortField, sortDirection);
      else
        fetchAllAcceptedOrders(page, pageSize, {
          ...filter,
          status: updatedStatus,
        }, sortField, sortDirection);
    } else
      openOrderRequests(page, pageSize, { ...filter, status: updatedStatus }, sortField, sortDirection);
  
  };

  useEffect(() => {
    reloadOrderRequest();
  }, []);

  const reloadOrderRequest = () => {
    if (currentPath === "/master/active-order") 
      fetchUserRole();
    else 
      openOrderRequests(page, pageSize, filter, sortField, sortDirection);
  }

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDeleteFile = (indexToDelete: number) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToDelete)
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {

      const newFiles = Array.from(event.target.files);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);

      // Clear the input value to allow selecting the same file again
      event.target.value = "";
    }
  };

  const uploadOrderRequestDocs = async () => {
  
    const formData = new FormData();
    let response;
    let OrderRequestDoc = {};

    if (ttbFile && Array.isArray(ttbFile)) {
      ttbFile.forEach(function (file: any) {
        formData.append("file", file);
      });
    }

    const fileNames = ttbFile.map((file) => file.name).join(", ");

    OrderRequestDoc = {
      orderRequestId: id,
      description: "uploaded " + fileNames + " document",
      userId: CommonService.getUserId(),
      title: fileNames,
      companyId: CommonService.getCompanyId()
    };

    formData.append(
      "param",
      new Blob([JSON.stringify(OrderRequestDoc)], {
        type: "application/json",
      })
    );

    response = await OrderApiService.uploadOrderRequestDocs(formData);
  };

  // const getStatusOptions = () => {
  //   const profile = CommonService.getDashboardPrefrence();

  //   switch (CommonService.getRole()) {
  //     case "SUPER_ADMIN":
  //       return (
  //         <>
  //           <option value="PENDING_REVIEW">Pending Review</option>
  //           <option value="UNDER_REVIEW">Under Review</option>
  //           <option value="ACCEPTED">Accepted</option>
  //           <option value="REJECTED">Rejected</option>
  //           <option value="IN_PROGRESS">In Progress</option>
  //           <option value="CONTRACT_SENT">Contract Sent</option>
  //           <option value="CONTRACT_EXECUTED">Contract Executed</option>
  //           <option value="INVOICE_SENT">Invoice Sent</option>
  //           <option value="PAYMENT_RECEIVED">Payment Received</option>
  //           <option value="OWNERSHIP_TRANSFERRED">Ownership Transferred</option>
  //           <option value="IN_TRANSIT">In Transit</option>
  //           <option value="CANCELLED">Cancelled</option>
  //           <option value="CLOSED">Closed</option>
  //         </>
  //       );
  //   }

  //   switch (profile) {
  //     case Constant.Profile.BUYER:
  //       return (
  //         <>
  //           <option value="PENDING_REVIEW">Pending Review</option>
  //           <option value="UNDER_REVIEW">Under Review</option>
  //           <option value="ACCEPTED">Accepted</option>
  //           <option value="REJECTED">Rejected</option>
  //           <option value="IN_PROGRESS">In Progress</option>
  //           <option value="CONTRACT_SENT">Contract Sent</option>
  //           <option value="CONTRACT_EXECUTED">Contract Executed</option>
  //           <option value="INVOICE_SENT">Invoice Sent</option>
  //           <option value="PAYMENT_RECEIVED">Payment Received</option>
  //           <option value="OWNERSHIP_TRANSFERRED">Ownership Transferred</option>
  //           <option value="IN_TRANSIT">In Transit</option>
  //           <option value="CANCELLED">Cancelled</option>
  //           <option value="CLOSED">Closed</option>
  //         </>
  //       );
  //     case Constant.Profile.OWNER:
  //       return (
  //         <>
  //           <option value="PENDING_REVIEW">Pending Review</option>
  //           <option value="ACCEPTED">Accepted</option>
  //           <option value="REJECTED">Rejected</option>
  //           <option value="ACCEPTED_REJECTED">Accepted | Rejected</option>
  //         </>
  //       );
  //     default:
  //       break;
  //   }  
  // };

  const getStatusOptions = () => {
    const profile = CommonService.getDashboardPrefrence();
    
    // Return all options for SUPER_ADMIN
    if (CommonService.getRole() === Constant.Role.SUPER_ADMIN) {
      return statusOptions;
    }
    
    // Filter options based on profile
    switch (profile) {
      case Constant.Profile.BUYER:
        return statusOptions; // Buyer sees all options
      case Constant.Profile.OWNER:
        // Owner only sees specific statuses
        return statusOptions.filter(option => 
          ["PENDING_REVIEW", "ACCEPTED", "REJECTED"].includes(option.value)
        );
      default:
        break;
    }
  };

  const columns: GridColDef[] = [
    {
      field: "requestNumber",
      headerName: "Request Number",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      minWidth: 190,
      sortable: true,
      renderCell: (params: any) => (
        <CellWithTooltip value={params.row.requestNumber || "-"} />
      ),
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "140px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.requestNumber}
              defaultValue={filter.requestNumber}
              onChange={(event) => handleFilterChange(event, "requestNumber")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    ...(CommonService.isAdmin()
    ? [
        {
          field: "companyName",
          headerName: "Account Owner Name",
          headerClassName: "table-header border-0 my-2 h-100",
          flex: 1,
          minWidth: 190,
          sortable: true,
          renderCell: (params: any) => (
            <CellWithTooltip value={params.value} />
          ),
          renderHeader: (params) => (
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>
              <div className="position-relative" style={{width:"140px"}}>
                <input
                  type="text"
                  className="form-control border mt-1"
                  style={{ textIndent: "24px", boxShadow: "none" }}
                  placeholder="Search"
                  //value={filter.companyName}
                  defaultValue={filter.companyName}
                  onChange={(event) =>
                    handleFilterChange(event, "companyName")
                  }
                  onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                />
                <SearchIcon
                  sx={{
                    color: "#6F6F6F",
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                  }}
                />
                </div>
              </div>
            ),
          },
        ]
      : []),
    {
      field: "modifiedDate",
      headerName: "Modified On",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      minWidth: 190,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.modifiedDate ? row.modifiedDate : null;
        const sellerModifiedDateTimeString = row.ownerOrderModifiedDate
          ? row.ownerOrderModifiedDate
          : null;

        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.isUser() &&
            !CommonService.isSameCompany(row.companyId)
            ? CommonService.formatDateTime(sellerModifiedDateTimeString)
            : CommonService.formatDateTime(dateTimeString);
        }
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div style={{ width: "140px" }}>
            <input
              type="date"
              className="form-control border mt-1"
              style={{ boxShadow: "none" }}
              id="birthdate"
              name="birthdate"
              placeholder="MM/DD/YYYY"
              value={
                CommonService.isUser() &&
                CommonService.getDashboardPrefrence() === Constant.Profile.OWNER
                  ? filter.ownerModifiedOn
                  : filter.modifiedOn
              }
              onChange={(event) =>
                handleFilterChange(
                  event,
                  CommonService.isUser() &&
                    CommonService.getDashboardPrefrence() ===
                      Constant.Profile.OWNER
                    ? "ownerModifiedOn"
                    : "modifiedOn"
                )
              }
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
          </div>
        </div>
      ),
    },
    {
      field: "createdDate",
      headerName: "Requested On",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      minWidth: 190,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.createdDate ? row.createdDate : null;
        const sellerCreatedDateTimeString = row.ownerOrderCreatedDate
          ? row.ownerOrderCreatedDate
          : null;

        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.isUser() &&
            !CommonService.isSameCompany(row.companyId)
            ? CommonService.formatDateTime(sellerCreatedDateTimeString)
            : CommonService.formatDateTime(dateTimeString);
        }
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div style={{ width: "140px" }}>
            <input
              type="date"
              className="form-control border mt-1"
              style={{ boxShadow: "none" }}
              id="birthdate"
              name="birthdate"
              placeholder="MM/DD/YYYY"
              value={
                CommonService.isUser() &&
                CommonService.getDashboardPrefrence() === Constant.Profile.OWNER
                  ? filter.ownerRequestedOn
                  : filter.requestedOn
              }
              onChange={(event) =>
                handleFilterChange(
                  event,
                  CommonService.isUser() &&
                    CommonService.getDashboardPrefrence() ===
                      Constant.Profile.OWNER
                    ? "ownerRequestedOn"
                    : "requestedOn"
                )
              }
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
          </div>
        </div>
      ),
    },
    ...(CommonService.isAdmin() ||
    CommonService.getDashboardPrefrence() == Constant.Profile.BUYER
      ? [
          {
            field: "firstName",
            headerName: "Requested By",
            flex: 1,
            minWidth: 190,
            sortable: true,
            valueGetter: (value: any, row: any) =>
              `${row.firstName || ""} ${row.lastName || ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
              <CellWithTooltip value={params.value} />
            ),
            renderHeader: (params) => (
              <div>
                <Typography
                  variant="body2"
                  sx={{ color: "#6F6F6F", fontSize: "14px" }}
                >
                  {params.colDef.headerName}
                </Typography>
                <div className="position-relative" style={{ width: "140px" }}>
                  <input
                    type="text"
                    className="form-control border mt-1"
                    style={{ textIndent: "24px", boxShadow: "none" }}
                    placeholder="Search"
                    //value={filter.firstName}
                    defaultValue={filter.firstName}
                    onChange={(event) => handleFilterChange(event, "firstName")}
                    onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                  />
                  <SearchIcon
                    sx={{
                      color: "#6F6F6F",
                      position: "absolute",
                      top: "50%",
                      left: "8px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            ),
          },
        ]
      : []),
    {
      field: "totalInventories",
      headerName: "Total Inventories",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      minWidth: 170,
      sortable: true,
      renderCell: (params: any) => (
        <CellWithTooltip value={params.value} />
      ),
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.totalInventories}
              onChange={(event) =>
                handleFilterChange(event, "totalInventories")
              }
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "quantity",
      headerName: "Total Quantity",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      minWidth: 190,
      sortable: true,
      renderCell: (params: any) => (
        <CellWithTooltip value={`${params.value} container`} />
      ),
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "140px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.quantity}
              defaultValue={filter.quantity}
              onChange={(event) => handleFilterChange(event, "quantity")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "finalAmount",
      headerName: "Total Amount",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      minWidth: 190,
      sortable: true,
      renderCell: (params: any) => (
        <CurrencyFormatter
          amount={params.value}
          locale="en-US"
          currency="USD"
        />
      ),
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "140px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.finalAmount}
              defaultValue={filter.finalAmount}
              onChange={(event) => handleFilterChange(event, "finalAmount")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "status-badge",
      flex: 1,
      minWidth: 320, // Allow it to grow if there is extra space
      sortable: true,
      renderCell: (params: any) => {
        const isStatusValid = params.row.hasValidStatus || false;
        const isItemRejected = params.row.hasItemRejected || false;
        const isRelocationFlag = params.row.relocationFlag || false;
        return (
          <div onClick={(e) => e.stopPropagation()}>
            {/* Pending Review - User */}
            {([
              "PENDING_REVIEW",
              "UNDER_REVIEW",
              "ACCEPTED",
              "IN_PROGRESS",
              "CONTRACT_SENT",
              "CONTRACT_EXECUTED",
              "INVOICE_SENT",
              "PAYMENT_RECEIVED",
              "OWNERSHIP_TRANSFERRED",
              "IN_TRANSIT",
              "REJECTED",
            ].includes(params.row.status) ||
              params.row.status === "ACCEPTED_REJECTED") &&
              CommonService.isUser() && (
                <StatusDropdown
                  currentStatus={params.row.status}
                  onStatusChange={(newStatus) =>
                    handleStatusChange(
                      newStatus,
                      params.row.status,
                      params.row.id,
                      params.row.quantity
                    )
                  }
                  disableCondition={
                    CommonService.isAdmin() ||
                    (!CommonService.isSameUser(params.row.createdBy) &&
                      CommonService.isSameCompany(params.row.companyId) &&
                      CommonService.getRole() === Constant.Role.USER) ||
                    !CommonService.isSameCompany(params.row.companyId) ||
                    [
                      "OWNERSHIP_TRANSFERRED",
                      "IN_TRANSIT",
                      "REJECTED",
                    ].includes(params.row?.status)
                  }
                  allowedLabels={["Cancelled"]}
                />
              )}

            {(params.row?.status === "PENDING_REVIEW" ||
              params.row?.status === "UNDER_REVIEW") &&
              CommonService.isAdmin() && (
                <StatusDropdown
                  currentStatus={params.row.status}
                  onStatusChange={(newStatus) =>
                    handleStatusChange(
                      newStatus,
                      params.row.status,
                      params.row.id,
                      params.row.quantity
                    )
                  }
                  disableCondition={
                    CommonService.isUser() ||
                    params.row.status === "CANCELLED" ||
                    params.row.status === "REJECTED"
                  }
                  allowedLabels={
                    isStatusValid
                      ? ["Under Review", "Rejected"]
                      : isItemRejected
                      ? ["Under Review", "Rejected"]
                      : ["Under Review", "Accepted", "Rejected"]
                  }
                />
              )}

            {/* Accepted to Payment Received - Both User and Admin */}
            {[
              "ACCEPTED",
              "REJECTED",
              "IN_PROGRESS",
              "CONTRACT_SENT",
              "CONTRACT_EXECUTED",
              "INVOICE_SENT",
              "PAYMENT_RECEIVED",
            ].includes(params.row?.status) &&
              CommonService.isAdmin() && (
                <StatusDropdown
                  currentStatus={formatStatus(params.row?.status)}
                  onStatusChange={(newStatus) =>
                    handleStatusChange(
                      newStatus,
                      params.row.status,
                      params.row.id,
                      params.row.quantity
                    )
                  }
                  disableCondition={
                    CommonService.isUser() ||
                    params.row?.status === "CANCELLED" ||
                    params.row?.status === "REJECTED"
                  }
                  allowedLabels={[
                    "In Progress",
                    "Contract Sent",
                    "Contract Executed",
                    "Invoice Sent",
                    "Payment Received",
                    "Ownership Transferred",
                    "Rejected",
                  ]}
                />
              )}

            {params.row?.status === "OWNERSHIP_TRANSFERRED" &&
              CommonService.isAdmin() && (
                <StatusDropdown
                  currentStatus={formatStatus(params.row?.status)}
                  onStatusChange={(newStatus) =>
                    handleStatusChange(
                      newStatus,
                      params.row.status,
                      params.row.id,
                      params.row.quantity
                    )
                  }
                  disableCondition={CommonService.isUser()}
                  allowedLabels={[
                    "Send to Warehouse"
                  ]}
                />
              )}

              {["SEND_TO_WAREHOUSE", "IN_PROCESS"].includes(params.row?.status) && (
                <StatusDropdown
                  currentStatus={formatStatus(params.row?.status)}
                  onStatusChange={(newStatus) =>
                    handleStatusChange(
                      newStatus,
                      params.row.status,
                      params.row.id,
                      params.row.quantity
                    )
                  }
                  disableCondition={CommonService.isUser()}
                  allowedLabels={
                    CommonService.isAdmin()
                      ? [
                        "Admin Accepted for Warehouse"
                      ]
                      : [
                        "In Process",
                        "Reassign to Admin",
                        "Warehouse Completed"
                      ]
                  }
                />
              )}

            {["ADMIN_ACCEPTED_FOR_WAREHOUSE", "REASSIGN_TO_ADMIN", "WAREHOUSE_COMPLETED"].includes(params.row?.status) && (
                <StatusDropdown
                  currentStatus={formatStatus(params.row?.status)}
                  onStatusChange={(newStatus) =>
                    handleStatusChange(
                      newStatus,
                      params.row.status,
                      params.row.id,
                      params.row.quantity
                    )
                  }
                  disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                  allowedLabels={[
                    ...(params.row?.status === "REASSIGN_TO_ADMIN") ? ["Send to Warehouse"] : [],
                    ...(isRelocationFlag ? ["In Transit"] : []),
                    "Closed",
                  ]}
                />
              )}

            {params.row?.status === "IN_TRANSIT" && (CommonService.isAdmin() || CommonService.isWarehouse()) && (
              <StatusDropdown
                currentStatus={formatStatus(params.row?.status)}
                onStatusChange={(newStatus) =>
                  handleStatusChange(
                    newStatus,
                    params.row.id,
                    params.row?.status,
                    params.row?.quantity
                  )
                }
                disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                allowedLabels={["Closed"]}
              />
            )}

            {/* Ownership Transferred or Cancelled - Both User and Admin (disabled) */}
            {(params.row?.status === "CLOSED") && (
              <StatusDropdown
                currentStatus={formatStatus(params.row?.status)}
                onStatusChange={(newStatus) =>
                  handleStatusChange(
                    newStatus,
                    params.row.status,
                    params.row.id,
                    params.row.quantity
                  )
                }
                disableCondition={true}
                allowedLabels={[]}
              />
            )}

          {(params.row?.status === "CANCELLED") && (
              <StatusDropdown
                currentStatus={formatStatus(params.row?.status)}
                onStatusChange={(newStatus) =>
                  handleStatusChange(
                    newStatus,
                    params.row.status,
                    params.row.id,
                    params.row.quantity
                  )
                }
                disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                allowedLabels={['Closed']}
              />
            )}

            {(params.row.status === "REJECTED" ||
              params.row.status === "CANCELLED") &&
              params.row.rejectionNote && (
                <Tooltip
                  title={`Rejection Note: ${params.row.rejectionNote}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )}
          </div>
        );
      },
      renderHeader: (params) => (
        <>
          {/* <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{width:"180px"}}>
              <Form.Select
                style={{
                  cursor: "pointer",
                  borderBottomColor: "#D1D1D1",
                  marginTop: "4px",
                }}
                value={filter.status}
                className="form-control mb-1"
                onChange={(event) => handleFilterChange(event, "status")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              >
                <option value="">Select Status</option>
                {getStatusOptions()}
              </Form.Select>
            </div>
          </div> */}

          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>

            <div className="position-relative" style={{ width: "280px" }}>
              <div
                className="form-control mb-1"
                style={{
                  cursor: "pointer",
                  borderBottomColor: "#D1D1D1",
                  marginTop: "4px",
                  background: "#fff",
                  padding: "5px",
                  overflowX:"hidden",
                  paddingRight:"16px",
                  textOverflow:"ellipsis",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  toggleDropdown();
                }}
                ref={buttonRef}
              >
                {filter.status?.length > 0
                  ? CommonService.formatStatus(filter.status).join(", ")
                  : "Select Status"}
              <img src={ExpandMore} className="position-absolute top-50 end-0 translate-middle" />
                
              </div>

              {/* Custom Dropdown */}
              {showDropdown && (
                <div
                  className="dropdown-menu show status-multiselect-dropdown"
                  onClick={(event) => event.stopPropagation()}
                  ref={divRef}
                >
                  {getStatusOptions().map((option) => (
                    <Form.Check
                      key={option.value}
                      id={`status-${option.value}`}
                      type="checkbox"
                      label={option.label}
                      value={option.value}
                      checked={
                        filter.status?.split(",").includes(option.value) ||
                        false
                      }
                      onChange={(event) => {
                        event.stopPropagation();
                        handleStatusFilterChange(
                          event,
                          option.value,
                          filter.status
                        );
                      }}
                      className="cursor-pointer"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
  ].filter(Boolean) as GridColDef[];

  const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

  const handleSelectionModelChange = (newSelection: GridRowId[]) => {
    setSelectionModel(newSelection);
    const newSelectedRows = newSelection.map((id: GridRowId) => {
      return tableData.find((row: any) => row.id === id); // Assuming each row object has an 'id' property
    });
    selectedRows.current = newSelectedRows;
    let flag: any = false;
    flag = selectedRows.current.some((user) => user.userStatus === "INVITED");
    disableAction.current = flag;
  };

  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };

  const onPaginationModelChange = (newPaginationModel) => {
    setPage(newPaginationModel.page);
    setPageSize(newPaginationModel.pageSize);

      if (currentPath === '/master/active-order'){
        if(isNeedReviewClicked)
          justShowPendingOrders(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
        else
          fetchAllAcceptedOrders(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
      }else
        openOrderRequests(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);  
  };

  const handleSortChange = (sortModel) => {
    if (sortModel.length > 0) {
        const newSortField = sortModel[0].field;
        const newSortDirection = sortModel[0].sort; // "asc" or "desc" directly from DataGrid
        
        setSortField(newSortField);
        setSortDirection(newSortDirection);
        
        if (currentPath === '/master/active-order'){
          if(isNeedReviewClicked)
            justShowPendingOrders(page,pageSize,filter, newSortField, newSortDirection);
          else
            fetchAllAcceptedOrders(page ,pageSize,filter, newSortField, newSortDirection);
        }else
          openOrderRequests(page,pageSize,filter, newSortField, newSortDirection);  
    }
  };  

  // Filter rows based on search query
  // const filteredRows = tableData?.filter(
  //   (row) =>
  //     CommonService.isAdmin() ?
  //       row.requestNumber?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.companyName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.firstName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.lastName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.email?.toLowerCase().includes(search?.toLowerCase()) ||
  //       (row.firstName + " " + row.lastName).toLowerCase().includes(search?.toLowerCase())
  //     :
  //       row.requestNumber?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.companyName?.toLowerCase().includes(search?.toLowerCase())
  // );

  // Map filtered rows with unique IDs
  // const tableDataWithIds = filteredRows.map((rowData, index) => ({
  //   ...rowData
  // }));

  return (
    <>
      <div
        className="usersList"
        style={{ paddingBottom: CommonService.isAdmin() ? 51 : "" }}
      >
        <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center">
          {CommonService.isAdmin() && (
            <IconButton
              onClick={handleBack}
              aria-label="ArrowBackIcon"
              sx={{
                backgroundColor: "#FFF",
                "&:hover": { backgroundColor: "#FFF" },
              }}
            >
              <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
            </IconButton>
          )}
          <div className="header--title me-2">
            <h1 className="title mb-0 ms-2">
              {CommonService.isAdmin() && "Order Requests"}{" "}
              <i className="bi bi-heart-fill"></i>
            </h1>
          </div>
          <div className="header--menu ms-auto mb-2">
            <div className="header--menu-items row d-flex justify-content-end">
              <div className="col-auto mb-2">
                {/* <SearchBar search={search} setSearch={setSearch} /> */}
              </div>
              {/* {CommonService.getRole() === "SUPER_ADMIN" && (
                <div className="col-auto menu-items__btnGroup btnGroup-border d-inline-flex mb-2">
                  <button
                    className={`white-outline-btn d-inline-flex justify-content-between align-items-center ms-1 pe-1 ${
                      isNeedReviewClicked ? "bg-white" : ""
                    }`}
                    onClick={() => {
                      showPendingOrders(page, pageSize, filter);
                    }}
                  >
                    Need Review
                    <span
                      className={`review--number d-inline-flex align-items-center justify-content-center rounded-circle bg-white ms-2 ${
                        isNeedReviewClicked ? "bg-secondary-subtle" : "bg-white"
                      }`}
                    >
                      {reviewOrderCount}
                    </span>
                  </button>
                </div>
              )}{" "} */}
              {/* <div className="col-auto menu-items__btnGroup d-inline-flex mb-2"> */}
              {/* {isNeedReviewClicked && !disableAction.current && (
                  <button className="white-outline-btn me-1">
                   
                  </button>
                )}
                {isNeedReviewClicked && !disableAction.current && (
                  <button className="white-outline-btn d-inline-flex justify-content-between align-items-center ms-1">
                    
                  </button>
                )} */}
              {/* <button className="white-outline-btn d-inline-flex justify-content-between align-items-center ms-1">
                  Delete
                </button> */}
              {/* <span className="counting d-inline-flex justify-content-between align-items-center ms-2">
                  {selectionModel.length}
                </span> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="user-table-container">
          <div className="userTable">
          <DataGrid
                      rows={tableData}
                      columns={columns}
                      className="data-grid support-req--listing"
                      initialState={{
                        pagination: {
                            paginationModel: { page, pageSize },
                        },
                      }}
                      pagination
                      paginationModel={{page, pageSize }}
                      rowCount={totalCount}
                      paginationMode="server"
                      sortingMode="server"
                      pageSizeOptions={[10, 20, 50, 100]}
                      // checkboxSelection
                      disableRowSelectionOnClick={true}
                      rowSelectionModel={selectionModel}
                      onSortModelChange={handleSortChange}
                      onPaginationModelChange={onPaginationModelChange}
                      onRowSelectionModelChange={handleSelectionModelChange}
                      localeText={localeText}
                      onRowClick={(params) => handleRowClick(params)}
                      loading={isLoading}
                      slots={{
                        loadingOverlay: DataGridLoader,
                      }}
                      disableColumnResize
                    />
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Update Order Request Status</Modal.Title>
          {isApproved && (<>
            {statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT && <p className="modal-text mt-2">
              Please Enter Track Number
            </p>}
            {statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED && <p className="modal-text mt-2">
              Please Enter Date of transfer
            </p>}
          </>)}
          {!isApproved && !isBeforeCancel && !isAfterCancel && statusDetailsRef.current.status != Constant.OrderStatus.CLOSED && (
            <p className="modal-text mt-2">
              Are you sure, you want to change status to {formatStatus(statusDetailsRef.current.status)}?
            </p>
          )}
          {isBeforeCancel && (
            <p className="modal-text mt-2">
              Are you sure, you want to cancel?
            </p>
          )}
          {isAfterCancel && (
            <p className="modal-text mt-2">
              Are you sure, you want to cancel? A cancellation charge may apply.
            </p>
          )}
          {statusDetailsRef.current.status === Constant.OrderStatus.CLOSED && (
            <p className="modal-text mt-2">
              Once the request is closed, it cannot be reopened. Are you sure you want to close it?
            </p>
          )}
        </Modal.Header>
        {["OWNERSHIP_TRANSFERRED", "SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.status) && (
        <Modal.Body>
          {isApproved && (<>
            <div className="form__inner">
             {statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT && <>
              <label className="modal-body__title mb-1">Track Number</label>
              <Form.Control
                className={`form-control ${error ? "is_invalid" : ""}`}
                type="text"
                value={trackNumberValue}
                onChange={handleInputChange}
                placeholder="Enter Tracking Number..."
              /></>}

              {statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED && <>
              <label className="modal-body__title mb-1">Date of transfer</label>
              <Form.Control
                type="date"
                placeholder="OwnershipTransferDate"
                value={ownershipTransferDateValue}
                onChange={handleInputChange}
                onClick={handleDateClick}
                className={`form-control ${error ? "is_invalid" : ""}`}
                min={CommonService.getTodayInTimeZone()}
              /></>}
              {error && <div className="error-message">{error}</div>}
            </div>
            </>)}
          {((!isApproved && !isInWarehouse) || isBeforeCancel || isAfterCancel) && (
            <form className="form__inner">
              <textarea
                required
                className={`form-control ${error ? "is_invalid" : ""}`}
                aria-label="With textarea"
                value={rejectionNoteValue}
                onChange={handleInputChange}
                rows={8}
                style={{ resize: "none" }}
                placeholder="Enter text here..."
              />
              {/* <span className="ms-auto">{rejectionNoteValue.length}/500</span> */}
              {error && <div className="error-message">{error}</div>}
            </form>
          )}
          {isInWarehouse && (
            <div className="form__inner">
              <label className="modal-body__title mb-1">Select Warehouse</label>
              <Select
                className={`select-company-dropdown form-control w-100 multi-select-dropdown ${error ? "is_invalid" : ""
                  }`}
                options={warehouseUserList.map((user) => ({
                  value: user.userId,
                  label: user.userName,
                }))}
                onChange={handleWarehouseUserChange}
                components={{
                  DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                  IndicatorSeparator: () => null, // Remove the default separator
                }}
                isSearchable
                placeholder="Select Warehouse"
              />
              {error && <div className="error-message">{error}</div>}
            </div>
          )}

          {isApproved && statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT && (
            <div className="d-flex align-items-center h-100 mt-2">
            <div className="create-ticket-attachement-wrapper d-flex flex-wrap align-items-center gap-1">
              <IconButton
                type="button"
                aria-label="submit"
                sx={{
                  transform: "rotate(45deg)",
                  padding: "8px",
                }}
                onClick={handleButtonClick}
              >
                <AttachFileIcon />
              </IconButton>
              <span className="cursor-pointer" onClick={handleButtonClick}>
                Upload Document
              </span>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {files?.map((file, index) => (
                  <div
                    className="file__upload--info d-flex align-items-center mb-1 me-2"
                    key={index}
                  >
                    <div className="file-name me-3">{file.name}</div>
                    <div className="file-delete">
                      <img
                        src={TrashIcon}
                        alt="TrashIcon"
                        onClick={() => handleDeleteFile(index)}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ position: "relative" }}>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  multiple
                  onChange={handleFileChange}
                />
              </div>
            </div>
            </div>
          )}
        </Modal.Body>)}

        <Modal.Footer className={`justify-content-center 
          ${(["OWNERSHIP_TRANSFERRED", "SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.status)) ? '' : 'bg-transparent'}`}>
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isLoading}
              >
                No
              </button>
            </div>

            <div className="col-6 pe-0">
              <button
                className="primary-btn w-100"
                onClick={changeOrderStatus}
                disabled={isLoading}
              >
                {isLoading && <Spinner />} 
                {statusDetailsRef.current?.status === "REJECTED"
                  ? "Reject Request"
                  : statusDetailsRef.current?.status === "CANCELLED"
                    ? "Cancel Request"
                    : "Yes"}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActiveOrder;